module.exports = __webpack_public_path__ + "app-static/img/p_07.e99c9780.jpg";